import { getSubmodelRankList } from "@/api/panel";

export default {
  namespaced: true,
  state: {
    ym: "",
    tableData: {},
  },
  mutations: {
    SET_DATA: (state, { ym, tableData }) => {
      state.ym = ym;
      state.tableData = tableData;
    },
  },
  actions: {
    getSubmodelRankList({ commit }, data) {
      getSubmodelRankList(data).then((response) => {
        const { data } = (response && response.data) || { data };
        if (!data) return;
        const ym = String(data.month).padStart(2, "0");
        const tableData = data.salesRanks || [];
        if (data) commit("SET_DATA", { ym, tableData });
      });
    },
  },
};
